import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EstimateDragDropTargetInfo, EstimateDragItemTypes } from './domain';

@Injectable({
    providedIn: 'root',
})
export class EstimateMeasurementsDragDropService {
    // @ts-ignore TS2564
    private targetInfo: EstimateDragDropTargetInfo;
    public get dragTargetInfo(): EstimateDragDropTargetInfo {
        return this.targetInfo;
    }

    public currentScrollY?: number;

    public isDraging = false;
    // @ts-ignore TS2564
    private measurementListElement: HTMLElement;
    private readonly dragDisabledClass = 'cdk-drag-disabled';

    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    public updateItemPosition(positionX: number, positionY: number, itemType: EstimateDragItemTypes, movingDirection: number) {
        const targetElement = this.getTargetElement(positionX, positionY, itemType);
        if (!targetElement) {
            // @ts-ignore TS2322
            this.targetInfo = { itemType: null, categoryId: null, order: null };
            return;
        }

        // @ts-ignore TS2531
        const targetData = targetElement.getAttribute('data-index').split('_');

        this.targetInfo = {
            itemType: itemType,
            // @ts-ignore TS2322
            categoryId: itemType === EstimateDragItemTypes.Measurement && targetData[1] !== 'null' ? targetData[1] : null,
            order:
                targetData[0] === itemType || targetData[1] === 'null'
                    ? // @ts-ignore TS2345
                      this.calculateDropPosition(targetElement, positionY, parseInt(targetData[2]))
                    : 1,
        };

        this.scroll(positionY, movingDirection);
    }

    private getTargetElement(positionX: number, positionY: number, itemType: EstimateDragItemTypes): Element {
        const element = this.document.elementFromPoint(positionX, positionY);
        if (!element) {
            // @ts-ignore TS2322
            return null;
        }

        const categoryElement = element.closest(`.${EstimateDragItemTypes.Category}-container`);
        if (!categoryElement || itemType === EstimateDragItemTypes.Category) {
            // @ts-ignore TS2322
            return categoryElement;
        }

        const measurementElements = categoryElement.getElementsByClassName(`${EstimateDragItemTypes.Measurement}-container`);
        if (!measurementElements.length) {
            return categoryElement;
        }

        for (let index = 0; index < measurementElements.length; index++) {
            const measurementElement = measurementElements.item(index);

            // @ts-ignore TS2531
            if (!measurementElement.classList.contains(this.dragDisabledClass)) {
                continue;
            }

            // @ts-ignore TS2531
            const measurementRect = measurementElement.getBoundingClientRect();
            if (
                (index === 0 && measurementRect.top >= positionY) ||
                (measurementRect.top < positionY && measurementRect.top + measurementRect.height >= positionY)
            ) {
                // @ts-ignore TS2322
                return measurementElement;
            }
        }

        // @ts-ignore TS2322
        return measurementElements.item(measurementElements.length - 1);
    }

    private calculateDropPosition(targetElement: Element, positionY: number, order: number): number {
        const targetRect = targetElement.getBoundingClientRect();
        const checkPoint = targetRect.height / 2;
        return positionY - targetRect.top < checkPoint ? order : order + 1;
    }

    private scroll(positionY: number, movingDirection: number) {
        if (!this.measurementListElement) {
            // @ts-ignore TS2322
            this.measurementListElement = this.document.getElementById('measurement-list');
        }

        const rect = this.measurementListElement.getBoundingClientRect();

        if (
            (movingDirection < 0 && this.measurementListElement.scrollTop + rect.top > positionY) ||
            (movingDirection > 0 && this.measurementListElement.scrollTop + rect.top < positionY)
        ) {
            this.measurementListElement.scrollTo({ top: positionY - rect.top, behavior: 'smooth' });
        }
    }
}
